<template>
  <div v-if="data">
    <slot name="paginatedData" :paginatedData="paginatedData"></slot>
    <div class="paginator-numbers">
      <span
      :class="`${pageNumber === currentSelectedPage + 1 ? 'active' : ''}`"
        v-for="pageNumber in lastPageNumber"
        :key="'pageN' + pageNumber"
        @click="currentSelectedPage = (pageNumber -1)"
      >{{pageNumber}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Paginator",
  props: {
    data: {
      type: Array,
      required: true
    },
    paginationSize: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      lastPageNumber: 0,
      currentSelectedPage: 0,
      paginatedData: []
    };
  },
  mounted() {
    this.calculatePaginationSize();
    this.updateDataReturned();
  },
  watch: {
    data: function(newV, oldV) {
      if (JSON.stringify(newV) === JSON.stringify(oldV)) return;
      this.calculatePaginationSize();
      this.updateDataReturned();
    },
    currentSelectedPage: function(newV, oldV) {
      if (JSON.stringify(newV) === JSON.stringify(oldV)) return;
      this.updateDataReturned();
    }
  },
  methods: {
    calculatePaginationSize() {
      this.lastPageNumber = Math.ceil(this.data.length / this.paginationSize);
    },
    updateDataReturned() {
      const allData = JSON.parse(JSON.stringify(this.data));
      this.paginatedData = allData.splice(
        this.currentSelectedPage * this.paginationSize,
        Math.min(
          this.paginationSize,
          allData.length - this.currentSelectedPage * this.paginationSize
        )
      );
    }
  }
};
</script>

<style lang="scss" scoped>
  .paginator-numbers{
    display: flex;
    flex-wrap: wrap;
    span{
      cursor: pointer;
      font-size: 3rem;
      margin-right: 8px;
    }
    .active{
      color: green;
    }
  }
</style>
